import React, { useState } from "react";
import "./videoSection.css";

const VideoSection = ({ title, subtitle, videoId }) => {
  const [play, setPlay] = useState(false);

  const thumbnail = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

  const handleClick = () => {
    if (!play) {
      setPlay(true);
    } else {
      window.open(`https://www.youtube.com/watch?v=${videoId}`, "_blank");
    }
  };

  return (
    <section className="yt-section">

      <div className="yt-header">
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>

      <div className="yt-video-wrapper" onClick={handleClick}>

        {!play ? (
          <>
            <img src={thumbnail} alt="thumbnail" className="yt-thumbnail" />
            <div className="yt-play">▶</div>
          </>
        ) : (
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            title="YouTube video"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        )}

      </div>

    </section>
  );
};

export default VideoSection;